import { Button, Card, Checkbox, Form, Input, message, Spin, Upload, Tooltip } from 'antd';
import React from 'react';
import { CopyOutlined, LoadingOutlined, PlusOutlined, QuestionCircleOutlined } from '@ant-design/icons';

class Create extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      uploadFile: true,
      count: 1,
      fileList: [],
      file: null,
      loading: false,
      showUploadList: false,

      fileListFavicon: [],
      fileFavicon: null,
      //showUploadListFavicon: false,
      isEnabled: {},
      // needFuelDailyReportNotification: false,
    }
  }

  componentDidMount() {
    const { match, fetch, authUser } = this.props;
    // console.log(fetch, authUser);
    // console.log((authUser && authUser.organisation && authUser.organisation._id))
    if (authUser && authUser.organisation && authUser.organisation._id) {
      // console.log(authUser.organisation._id);
      fetch(authUser.organisation._id);
    }
  }

  componentWillReceiveProps(nextprops) {
    if (nextprops && nextprops.data && JSON.stringify(nextprops.data) !== JSON.stringify(this.props.data)) {
      this.setState({
        isEnabled: {
          isSmsEnabled: nextprops.data.isSmsEnabled || false,
          isEmailEnabled: nextprops.data.isEmailEnabled || false,
          isSlackEnabled: nextprops.data.isSlackEnabled || false,
          isPushEnabled: nextprops.data.isPushEnabled || false,
          isWhatsappEnabled: nextprops.data.isWhatsappEnabled || false,
          // needFuelDailyReportNotification: nextprops.data.needFuelDailyReportNotification || false,
        }
      })
    }
  }

  fallbackCopy = (value, done) => {
    try {
      const ta = document.createElement('textarea');
      ta.value = value;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      done();
    } catch (err) {
      message.error('Copy failed');
    }
  };

  handleCopyToken = () => {
    const value = this.props.form.getFieldValue('accessToken');
    if (!value) {
      message.warning('No access token to copy');
      return;
    }
    const done = () => message.success('Access token copied');
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(value).then(done).catch(() => this.fallbackCopy(value, done));
    } else {
      this.fallbackCopy(value, done);
    }
  };

  handleSubmit = (e) => {
    const { match, form } = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      // console.log(values);
      if (err) {
        const { data } = this.props;
        if (data && data.logo) {
          if (Object.keys(err).length === 1 && Object.keys(err)[0] === 'files') {

          } else {
            return console.log(err);
          }
        } else {
          return console.log(err);
        }
      }
      const { authUser } = this.props;
      if (authUser && authUser.organisation && authUser.organisation._id) {
        this.props.onSubmit(values, this.props.authUser.organisation._id);
      }
    });
  };

  getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  customUpload = file => {
    this.setState(state => ({
      fileList: [file],
      file: file,
      showUploadList: true,
    }));
    return false;
  };

  customUploadFavicon = file => {
    this.setState(state => ({
      fileListFavicon: [file],
      file: file,
      showUploadList: true,
    }));
    return false;
  };

  handleChange = async info => {
    let fileList = [...info.fileList];
    fileList = fileList.slice(-1);
    this.setState({ fileList });
    if (info.file) {
      await this.getBase64(info.file, imageUrl =>
        this.setState({
          imageUrl,
          loading: false,
        })
      );
    }
  };

  handleChangeFavicon = async info => {
    let fileList = [...info.fileList];
    fileList = fileList.slice(-1);
    this.setState({ fileList });
    if (info.file) {
      await this.getBase64(info.file, imageUrlFavicon =>
        this.setState({
          imageUrlFavicon,
          loading: false,
        })
      );
    }
  };
  handleCheck = (e, type) => {
    // console.log(e.target.checked, type);
    const enabledObject = this.state.isEnabled;
    if (type === 'email') {
      enabledObject.isEmailEnabled = e.target.checked;
    }
    if (type === 'whatsapp') {
      enabledObject.isWhatsappEnabled = e.target.checked;
    }
    if (type === 'slack') {
      enabledObject.isSlackEnabled = e.target.checked;
    }
    if (type === 'sms') {
      enabledObject.isSmsEnabled = e.target.checked;
    }
    if (type === 'push') {
      enabledObject.isPushEnabled = e.target.checked;
    }
    // if (type === 'needFuelDailyReportNotification') {
    //   enabledObject.needFuelDailyReportNotification = e.target.checked;
    // }
    this.setState({
      isEnabled: enabledObject
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { data, loading, filters, title, resource, authUser, form } = this.props;
    const { imageUrl, imageUrlFavicon } = this.state;
    const parts = window.location.host.split('.');
    let domain = parts.slice(-2).join('.');
    // if(parts.includes('qa2')) {
    //   domain = 'tenent.qa2.' + domain;
    // }
    // console.log(loading);
    const uploadButton = (
      <div>
        {this.state.loading ? <LoadingOutlined /> : <PlusOutlined />}
        <div className="ant-upload-text">Upload</div>
      </div>
    );

    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`${title} Configuration`}>
          <Form onSubmit={this.handleSubmit} layout="vertical">

            <Form.Item key={'name'} label="Name">
              {getFieldDecorator('name', {
                rules: [{ required: false, message: `Name is required!` }],
                initialValue: (data && data['name'])
              })(<Input disabled />)}
            </Form.Item>

            {/* <Form.Item key={'needFuelDailyReportNotification'} label="Is Fuel Daily Report Notification Enabled">
              {getFieldDecorator('needFuelDailyReportNotification', {
                rules: [{ required: false, message: `Fuel Daily Report Notification is required!` }],
                initialValue: (data && data['needFuelDailyReportNotification'])
              })(<Checkbox checked={this.state.isEnabled.needFuelDailyReportNotification}
                onChange={(checked) => this.handleCheck(checked, 'needFuelDailyReportNotification')}
              />)}
            </Form.Item> */}

            <Form.Item key={'email'} label="Is Email Enabled">
              {getFieldDecorator('isEmailEnabled', {
                rules: [{ required: false, message: `Email is required!` }],
                initialValue: (data && data['isEmailEnabled'])
              })(<Checkbox checked={this.state.isEnabled.isEmailEnabled}
                onChange={(checked) => this.handleCheck(checked, 'email')}
              />)}
            </Form.Item>

            <Form.Item key={'push'} label="Is Push Enabled">
              {getFieldDecorator('isPushEnabled', {
                rules: [{ required: false, message: `Push is required!` }],
                initialValue: (data && data['isPushEnabled'])
              })(<Checkbox checked={this.state.isEnabled.isPushEnabled}
                onChange={(checked) => this.handleCheck(checked, 'push')}
              />)}
            </Form.Item>

            <Form.Item key={'sms'} label="Is WhatsApp Enabled">
              {getFieldDecorator('isWhatsappEnabled', {
                rules: [{ required: false, message: `WhatsApp is required!` }],
                initialValue: (data && data['isWhatsappEnabled'])
              })(<Checkbox checked={this.state.isEnabled.isWhatsappEnabled}
                onChange={(checked) => this.handleCheck(checked, 'whatsapp')} />)}
            </Form.Item>

            <Form.Item key={'slack'} label="Is Slack Enabled">
              {getFieldDecorator('isSlackEnabled', {
                rules: [{ required: false, message: `Slack is required!` }],
                initialValue: (data && data['isSlackEnabled'])
              })(<Checkbox onChange={(checked) => this.handleCheck(checked, 'slack')}
                checked={this.state.isEnabled.isSlackEnabled} />)}
            </Form.Item>

            <Form.Item key={'slackUrl'} label="Slack Channel URL">
              {getFieldDecorator('slackUrl', {
                rules: [{ required: this.state.isEnabled.isSlackEnabled, message: `Slack Url is required!` }],
                initialValue: (data && data['slackUrl'] && data['slackUrl'] !== 'null' ? data['slackUrl'] : '')
              })(<Input disabled={!this.state.isEnabled.isSlackEnabled} />)}
            </Form.Item>

            <Form.Item key={'shareIotJobCards'} label={
              <span>
                Share IOT related Job Cards
                <Tooltip title="Share all IOT related issues/jobcards/complaints to AssetPro team to analyse">
                  <QuestionCircleOutlined style={{ marginLeft: 8, color: '#1890ff', cursor: 'help' }} />
                </Tooltip>
              </span>
            }>
              {getFieldDecorator('shareIotJobCards', {
                rules: [{ required: false, message: `Share IOT related Job Cards is required!` }],
                initialValue: (data && data['shareIotJobCards'])
              })(<Checkbox disabled checked
                onChange={(checked) => this.handleCheck(checked, 'shareIotJobCards')} />)}
            </Form.Item>

            <Form.Item key={'accessToken'} label={
              <span>
                Access Token
                <Tooltip title="Access token stored for this organisation">
                  <QuestionCircleOutlined style={{ marginLeft: 8, color: '#1890ff', cursor: 'help' }} />
                </Tooltip>
              </span>
            }>
              {getFieldDecorator('accessToken', {
                rules: [{ required: false, message: `Access Token is required!` }],
                initialValue: (data && data['accessToken'] && data['accessToken'] !== 'null' ? data['accessToken'] : '')
              })(<Input.Password
                placeholder="Organisation access token"
                visibilityToggle
                autoComplete="new-password"
                addonAfter={
                  <Tooltip title="Copy access token">
                    <CopyOutlined style={{ cursor: 'pointer' }} onClick={this.handleCopyToken} />
                  </Tooltip>
                }
              />)}
            </Form.Item>

            <Form.Item key={'files'} label="Upload Logo">
              {getFieldDecorator('files', {
                rules: [{ required: false, message: `Logo is required!` }],
                initialValue: (data && data['file']) ? data['file'] : []
              })(
                <Upload
                  listType="picture-card"
                  className="avatar-uploader"
                  name="files"
                  onChange={this.handleChange}
                  showUploadList={false}
                  beforeUpload={this.customUpload}
                  fileList={this.state.fileList}
                >
                  {imageUrl || data && data.logo ?
                    <img src={imageUrl || data.logo} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
                </Upload>
              )}
            </Form.Item>
            <Form.Item key={'filesFavicon'} label="Favicon Icon">
              {getFieldDecorator('filesFavicon', {
                rules: [{ required: false, message: `Favicon is required!` }],
                initialValue: (data && data['favicon']) ? data['favicon'] : []
              })(
                <Upload
                  listType="picture-card"
                  className="avatar-uploader"
                  name="files"
                  onChange={this.handleChangeFavicon}
                  showUploadList={false}
                  beforeUpload={this.customUploadFavicon}
                  fileList={this.state.fileListFavicon}
                >
                  {imageUrlFavicon || data && data.favicon ?
                    <img src={imageUrlFavicon || data.favicon} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
                </Upload>
              )}
            </Form.Item>

            {
              title === 'EDIT' ? <div style={{ marginBottom: '10px' }}>
                URL of Organisation: <a target="_blank"
                  href={`${window.location.protocol}//${data && data['slug']}.${domain}`}>{window.location.protocol}//{data && data['slug']}.{domain}</a>
              </div> : ''
            }

            <Form.Item>
              <Button type="primary" className="gx-mb-0" htmlType="submit" loading={loading}>
                {this.props.title === 'EDIT' ? 'UPDATE' : 'CREATE'}
              </Button>
            </Form.Item>
          </Form>

        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'organisation_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
